import React from 'react';
import { Box, TableCell } from '@mui/material';
import Label from '../../components/label';
import { normalizeTagsValue } from '../../utils/formatName';
import i18n from '../../i18n';

export default class GridTagsCell extends React.Component {
    render() {
        const { field, value } = this.props;
        const parsedValue = value ? normalizeTagsValue(value) : [];

        // Two by default, then a count; a field whose tags are few and fixed can
        // show them all (maxTags).
        const visibleTags = parsedValue.slice(0, field.maxTags || 2);

        const remainingCount = parsedValue.length - visibleTags.length;

        // Tags from a fixed list of `items` are its values, and read as an Items
        // cell reads its one: enums.<value>, or enums.<enumGroup>.<value>.
        const translated = Array.isArray(field.items) && !field.noTranslate;
        const text = (tag) => {
            if (!translated) return tag;
            return i18n.t(field.enumGroup ? `enums.${field.enumGroup}.${tag}` : `enums.${tag}`);
        };

        return (
            <TableCell key={field.id} align="left">
                <Box sx={{ display: 'flex', justifyContent: 'start', gap: 1 }}>
                    {visibleTags.map((tag, index) => (
                        <Label key={index} sx={{ fontWeight: '500' }}>
                            {text(tag)}
                        </Label>
                    ))}
                    {remainingCount > 0 && (
                        <Label sx={{ fontWeight: '500' }}>
                            +{remainingCount}
                        </Label>
                    )}
                </Box>
            </TableCell>
        );
    }
}
